<template>
    <v-sheet style="height: 100%">
        <section
            class="px-4 d-flex flex-column overflow-y-auto"
            style="height: calc(100% - 68px)"
        >
            <div class="text-h5 bold">
                {{ amount }}
            </div>
            <div class="text-subtitle-2 mb-4">{{ amount_subtitle }}</div>

            <v-spacer />

            <div class="text-subtitle-1 bold mb-2">{{ translate('common.pick_new_due_date') }}</div>
            <div class="text-body-2 text-medium-emphasis mb-4">
                {{ creditor_information }}
            </div>

            <v-card
                :style="style"
                variant="outlined"
            >
                <v-date-picker
                    ref="datepicker"
                    v-model="date"
                    v-model:month="current_month"
                    :hide-header="true"
                    :max="max_date"
                    :min="min_date"
                    :show-adjacent-months="true"
                    width="100%"
                />
            </v-card>
        </section>
        <section class="ma-4 d-flex">
            <v-spacer />
            <v-btn
                @click="$emit('cancel')"
                class="mr-4"
                variant="flat"
            >
                {{ translate('common.cancel') }}
            </v-btn>
            <v-btn
                :disabled="!date"
                @click="handle_date"
                color="primary"
            >
                {{ translate('common.ok') }}
            </v-btn>
        </section>
    </v-sheet>
</template>

<script>
import { utils_mixin } from '@old/mixins/utils_mixin'
import { locales_mixin } from '@old/mixins/locales_mixin'
import { mapState } from 'vuex'
import { date_mixin } from '@old/mixins/date_mixin'
import { add, intervalToDuration } from 'date-fns'

export default {
    name: 'RespiteDate',
    props: {},
    mixins: [date_mixin, locales_mixin, utils_mixin],
    components: {},
    emits: ['cancel', 'confirm'],
    data() {
        return {
            date: undefined,
            current_month: undefined,
            datepicker_height: 0,
        }
    },
    computed: {
        amount() {
            const amount = this.deep_get(this.respite, 'document.ocr.amount', 0)
            const currency = this.deep_get(this.respite, 'document.ocr.currency', 'SEK')
            return this.format_as_currency(amount, currency)
        },
        amount_subtitle() {
            return this.deep_get(this.respite, 'document.ocr.creditor_name')
        },
        creditor_information() {
            const creditor_name = this.deep_get(this.respite, 'document.creditor_name', '')
            const max_days = this.deep_get(this.respite, 'params.days.max', 0)
            return this.translate('common.creditor_allows_respite_x_days', [creditor_name, max_days])
        },
        min_date() {
            const schedule_to_execute = new Date(this.respite.params.schedule_to_execute)
            const { min } = this.respite.params.days
            const min_date = add(schedule_to_execute, { days: min })
            return this.format_date(min_date)
        },
        max_date() {
            const schedule_to_execute = new Date(this.respite.params.schedule_to_execute)
            const { max } = this.respite.params.days
            const max_date = add(schedule_to_execute, { days: max })
            return this.format_date(max_date)
        },
        style() {
            return {
                'min-height': `${this.datepicker_height}px`,
            }
        },
        ...mapState(['respite']),
    },
    watch: {
        min_date: {
            handler(value) {
                const month = new Date(value).getMonth()
                this.current_month = month
            },
            immediate: true,
        },
    },
    methods: {
        handle_date() {
            const schedule_to_execute = new Date(this.respite.params.schedule_to_execute)
            const interval = intervalToDuration({
                start: new Date(schedule_to_execute).setHours(0, 0, 0, 0),
                end: new Date(this.date).setHours(0, 0, 0, 0),
            })
            const days = (interval.months || 0) * 30 + (interval.days || 0)

            this.$emit('confirm', { days: days, date: this.date })
        },
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        this.$nextTick(() => {
            this.datepicker_height = this.$refs.datepicker.$el.clientHeight
        })
    },
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
